import { render, staticRenderFns } from "./SearchShowOrdersReassignment.vue?vue&type=template&id=7567b83b&scoped=true"
import script from "./SearchShowOrdersReassignment.vue?vue&type=script&lang=js"
export * from "./SearchShowOrdersReassignment.vue?vue&type=script&lang=js"
import style0 from "./SearchShowOrdersReassignment.vue?vue&type=style&index=0&id=7567b83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567b83b",
  null
  
)

export default component.exports